import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';
import createReactClass from 'create-react-class'; // eslint-disable-line no-restricted-syntax
import bemify, { toModifiers } from 'bemify-js';

import Button from 'app/common/components/Button';
import Icon from 'app/common/components/Icon';
import NotificationBadge from 'app/viewport/components/NotificationBadge';
import NotificationShape from 'app/viewport/NotificationShape';
import ProgressCircle from 'app/common/components/ProgressCircle';
import { PROGRESS_TYPES } from 'app/viewport/utils/constants';
import 'app/viewport/components/Notification.scss';

const bem = bemify('notification');

const Notification = createReactClass({
  displayName: 'Notification',

  propTypes: {
    ...NotificationShape,
    onClick: PropTypes.func.isRequired,
    onDismissNotification: PropTypes.func.isRequired,
  },

  getDefaultProps() {
    return {
      hasBadge: true,
      hasButton: true,

      // Need to avoid divide by zero / NaN wonkiness in Progress.js,
      // so default to non-zero, 100% complete values:
      progressValue: 1,
      progressMax: 1,
    };
  },

  render() {
    const { props } = this;

    const buttonProps = props.link
      ? { tag: 'a', target: '_new', href: props.link, onClick: props.onClick }
      : { onClick: props.onClick };

    const progressType = PROGRESS_TYPES[props.badgeKind];
    const barWidth = progressType ? 3 : 0;

    const progressMax = props.progressMax;
    const progressValue = props.progressValue;

    return (
      <li className={bem(props.className)}>
        <div className={bem('__title-row')}>
          {!props.iconType ? null : (
            <div className={bem('__icon-column')}>
              <ProgressCircle
                barWidth={barWidth}
                diameter={49}
                max={progressMax}
                type={progressType}
                value={progressValue}
              />
              <div className={bem('__icon-wrap', toModifiers(props.badgeKind))}>
                <Icon className={bem('__icon')} type={props.iconType} />
              </div>
            </div>
          )}
          <div className={bem('__title-column')}>
            {props.hasBadge && <NotificationBadge kind={props.badgeKind} />}
            <div className={bem('__title')}>{props.title}</div>
          </div>
          {!props.isDismissable ? null : (
            <Icon
              className={bem('__close')}
              onClick={_.partial(props.onDismissNotification, props.id)}
              type="delete"
            />
          )}
        </div>
        <div className={bem('__message')}>
          {_.isFunction(props.message) ? (
            <props.message onClick={props.onClick} />
          ) : (
            props.message
          )}
        </div>
        {!props.hasButton ? null : (
          <Button
            {...buttonProps}
            className={bem('__button')}
            kind="secondary large"
          >
            {props.buttonText}
          </Button>
        )}
      </li>
    );
  },
});

export default Notification;
